import React from 'react'
import RouteNextVersion, { RouteNextProps } from './RouteNextVersion'

/**
 * Uplne normalni react-router-dom Route az na to,
 * ze ma parametr 'element', ktery nahrazuje 'component'
 * v novejsich verzich react-router-dom.
 *
 * Pozn.:
 * - component je predpis (typu React.ComponentType)
 * - element je immutable 'virtualni instance' v ramci React
 *
 * Vice viz:
 * - https://stackoverflow.com/questions/30971395/difference-between-react-component-and-react-element
 * - https://reactjs.org/blog/2015/12/18/react-components-elements-and-instances.html
 *
 * - https://www.w3schools.io/learn/react-typescript-functional-components/
 */
function PublicRoute(props: RouteNextProps) {
  return <RouteNextVersion {...props} />
}

export default PublicRoute
